import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import StopIcon from "assets/icons/StopIcon";
import PlayIcon from "assets/icons/PlayIcon";

interface RenderPWAStatusProps {
  pwaStatus: string;
}

export const RenderPWAStatus = ({ pwaStatus }: RenderPWAStatusProps) => {
  const { t } = useTranslation();

  if (pwaStatus === "active") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <PlayIcon />
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: 1.43,
            color: "#16B364",
            fontFamily: "var(--cygreRegular), sans-serif",
          }}
        >
          {t("working")}
        </Typography>
      </Box>
    );
  }
  if (pwaStatus === "pause") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <StopIcon />
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#F4701B",
            fontFamily: "var(--cygreRegular), sans-serif",
          }}
        >
          {t("paused")}
        </Typography>
      </Box>
    );
  }
  return null;
};
